module.exports = __webpack_public_path__ + "img/htkj_06.e615c5e3.jpg";